/**
 * This file is part of the box.co.il project.

 * (c) Alex Buturlakin alexbuturlakin@gmail.com
 */
;(function($) {
  $(document).ready(function() {

    // enable or disable blocks by click in switch link
    jQuery(document).on('click', '.link-switch', function (e) {
      var el     = $(this),
          open   = el.data('switch-open')    || '',
          toggle = el.data('switch-toggle')  || '',
          close  = el.data('switch-close')   || '';

      open   = $(open);
      close  = $(close);
      toggle = $(toggle);

      toggle.toggleClass('hidden');
      open.removeClass('hidden');
      close.addClass('hidden');

      e.preventDefault();
    });

    // populate form default values
    $('.populate-default-values').on('change', function() {
      var el        = $(this),
          selector  = el.data('populate-in'),
          container = typeof selector === typeof undefined || selector === false ? el.closest('form') : $(selector),
          name      = el.attr('name'),
          exclude   = el.data('populate-exclude');

      exclude = typeof exclude === typeof undefined || exclude === false ? [] : exclude.split('|');

      // add current el to exclude
      if(typeof name !== typeof undefined) {
        exclude.push(name);
      }
      
      if(1 == container.length) {
        if(undefined != el.prop('tagName') && 'select' == el.prop('tagName').toLowerCase()) {
          container.populateDefaultDataSelect(el.find('option:selected'), exclude);
        } else {
          container.populateDefaultData(el.prop('checked'), exclude);
        }
      }
    });

    // add/remove tel2 select box
    $('.tel-3').on('keyup', function() {
      var el   = $(this),
          selector  = el.data('tel-in'),
          container = typeof selector === typeof undefined || selector === false ? el.closest('form') : $(selector),
          tel2      = container.find('.tel-2').closest('.form-control-inner'),
          tel4      = container.find('.tel-4').closest('.form-control-inner');

      // fast fix for compatibility on different pages
      if(0 == tel2.length) {
        tel2 = container.find('.tel-2');
        tel4 = container.find('.tel-4');
      }
      
      // if is Israel number
      if('972' == el.val() && tel2.hasClass('hidden')) {
        tel2.removeClass('hidden');
        tel4.addClass('hidden');
      }

      // not Israel number
      if('972' != el.val() && tel4.hasClass('hidden')) {
        tel4.removeClass('hidden');
        tel2.addClass('hidden');
      }
    }).on('default-data-populated', function() {
      $(this).keyup();
    });

    // open support window
    $('.zendesk-open-window').click(function() {
      zE('messenger', 'open');

      return false;
    });

  });
})(jQuery);